<div class="vo-central-content">
  <div class="vo-main-content">
    <div class="vo-left-column">
      <div
        class="vo-heading-regular-28 mt-0"
        [innerHtml]="referenceDataLabels.CookiesPolicyPageTitle | localizeLabel"
      ></div>
      <div
        class="default-user-agent vo-link-inside"
        [innerHtml]="referenceDataLabels.CookiesPolicyPageContent | localizeLabel | toTrustedHtml"
      ></div>
    </div>

    <div class="vo-right-column vo-right-column-wider vo-sticky-content vo-sticky-content--small-sticky-header">
      <div class="vo-panel vo-panel-white text-break-word">
        <div class="vo-heading-regular-16" [innerHtml]="referenceDataLabels.ContactUs | localizeLabel"></div>
        <div
          class="vo-body-regular-14"
          [innerHtml]="referenceDataLabels.AgentProfileContactUsText | localizeLabel"
        ></div>
      </div>
    </div>
  </div>
</div>
